<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="№ п.п" v-bind="$form.input('number')" />
        <n-input title="Номер сварного соединения по чертежам (исполнительным чертежам)" v-bind="$form.input('weldingNum')" />
        <n-input title="Характеристика стыка, мм, Д х S, марка стали или композиция марок сталей, ГОСТ, ТУ, № сертификата" v-bind="$form.input('charsWelding')" />
        <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): Электроды" v-bind="$form.input('electrod')" />
        <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): Проволоки" v-bind="$form.input('provolka')" />
        <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): флюс" v-bind="$form.input('flus')" />
        <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): Защитный газ" v-bind="$form.input('guardingGas')" />
        <n-input title="Номер журнала проверки качества сварочных материалов, регистрационные номера проверок" v-bind="$form.input('journalNum')" />
        <n-input title="Положение стыка (поворотное, неповоротное, вертикальное, горизонтальное)" v-bind="$form.input('weldPlace')" />
        <n-datepicker inline title="Дата сварки" v-bind="$form.input('weldingDate')" />
        <n-input title="Способ сварки (прихватки, корень шва, заполнение разделки)" v-bind="$form.input('weldingWay')" />
        <n-input title="Температура воздуха в рабочей зоне, С" v-bind="$form.input('tempInside')" />
        <n-input title="Температура предварительного, сопутствующего подогрева стыка, С" v-bind="$form.input('tempHeating')" />
        <n-input title="Фамилия, Имя, Отчество сварщика, номер клейма" v-bind="$form.input('welder')" />
        <n-input title="Дата термической обработки сварного соединения, номер журнала термической обработки и регистрационный номер в журнале" v-bind="$form.input('dateTermDoing')" />
        <n-input title="Результаты внешнего осмотра и измерений, цветной или магнитной, порошковой дефектоскопии, номер протокола и дата" v-bind="$form.input('resultOut')" />
        <n-input title="Способ контроля качества сварки (радиографическая, ультразвуковая дефектоскопия)" v-bind="$form.input('controlWay')" />
        <n-input title="Дата проведения радиографического контроля или ультразвуковой дефектоскопии, номер заключения, номер журнала контроля" v-bind="$form.input('dateRadio')" />
        <n-input title="Результаты замера содержания ферритной фазы в наплавленном металле, номер протокола и дата" v-bind="$form.input('resultFerrit')" />
        <n-input title="Результаты замера содержания основных: легирующих элементов или стилоскопирования, номер протокола и дата" v-bind="$form.input('resultContain')" />
        <n-input title="Отметки об устраненных дефектах" v-bind="$form.input('problemSolve')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
